/*
  Shared behavior loaded on every page (included once from layout/theme.liquid):
  - hamburger / mobile-menu toggle (works no matter how many times the header
    section is rendered, since each instance is scoped to its own
    .shopify-section wrapper)
  - keeps every [data-cart-count] badge on the page in sync whenever any
    section dispatches a "cart:updated" custom event (product-form.js does
    this after a successful add-to-cart)
*/

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggleBtn) {
    var wrapper = toggleBtn.closest('.shopify-section') || document;
    var menu = wrapper.querySelector('[data-mobile-menu]');
    var closeBtn = wrapper.querySelector('[data-menu-close]');

    if (!menu) return;

    toggleBtn.addEventListener('click', function () {
      menu.classList.add('open');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        menu.classList.remove('open');
      });
    }
  });
});

document.addEventListener('cart:updated', function (event) {
  var cart = event.detail && event.detail.cart;
  if (!cart) return;

  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.setAttribute('data-cart-count', cart.item_count);
    if (cart.item_count > 0) {
      el.textContent = '(' + cart.item_count + ')';
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  });
});
